import { useTutorial } from "../../context/TutorialContext";
import { TutorialDemoBanner } from "./TutorialDemoBanner";
import "../../Css/Tutorial/TutorialDemoPages.css";

/** Persistent notice while the App Guide is open. */
export function TutorialGlobalBanner() {
  const { isTourActive } = useTutorial();
  if (!isTourActive) return null;

  return (
    <div className="tutorialGlobalBanner">
      <TutorialDemoBanner areaLabel="entire App Guide" />
    </div>
  );
}
